import type { ReactNode } from 'react';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { TooltipProvider } from '@/components/ui/tooltip';
import { QueryProvider } from './QueryProvider';
import { AuthProvider } from './AuthProvider';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Combines all app-level providers
 * Order matters: QueryProvider should wrap AuthProvider
 * since auth might use queries
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <NuqsAdapter>
        <TooltipProvider delayDuration={300}>
          <AuthProvider>{children}</AuthProvider>
        </TooltipProvider>
      </NuqsAdapter>
    </QueryProvider>
  );
}
